import { createAction } from 'redux-act';

export const checkEmail = createAction('check email');
export const reminderEmail = createAction('check email');
export const successCheckEmail = createAction('success check email');
export const failCheckEmail = createAction('fail check email');

export const registUser = createAction('regist user');
export const successRegistUser = createAction('success regist user');
export const failRegistUser = createAction('fail regist user');
export const setData = createAction('order set data');
export const successGetData = createAction('regist success get data');



// WEBPACK FOOTER //
// ./src/actions/regist.js